import { gql } from '@apollo/client';

const PartnerLocationInfoPartner = gql`
  fragment PartnerLocationInfoPartner on PartnerLocation {
    id
    name
    email
    phone
    website
    active
    imageUrl
    isAllowedFreeTrial
    insertImageUrl
    enablePaidInOffice
    hiresLogoUrl
    perArchEotFee
    scannerBrandId
    scannerBrand {
      id
      name
    }
    address {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
    partnerShippingAddress {
      id
      address
      address2
      city
      region
      postalCode
      country
      latitude
      longitude
    }
    partnerOrganizationId
    partnerOrganization {
      id
      name
    }
    createdAt
    updatedAt
  }
`;

export default PartnerLocationInfoPartner;
